import React, {Component} from 'react';
import VariantSelector from './VariantSelector';

class Product extends Component {
    constructor(props) {
        super(props);
        // console.log('product props: ', props)
        let defaultOptionValues = {};
        this.props.product.options.forEach((selector) => {
            defaultOptionValues[selector.name] = selector.values[0].value;
        });
        this.state = {selectedOptions: defaultOptionValues, selectedVariantQuantity: 1};

        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.findImage = this.findImage.bind(this);
    }

    findImage(images, variantId) {
        const primary = images[0];

        const image = images.filter(function (image) {
            return image.variant_ids.includes(variantId);
        })[0];

        return (image || primary).src;
    }

    handleOptionChange(event) {
        const target = event.target
        let selectedOptions = this.state.selectedOptions;
        selectedOptions[target.name] = target.value;

        const selectedVariant = this.props.client.product.helpers.variantForOptions(this.props.product, selectedOptions)

        this.setState({
            selectedVariant: selectedVariant,
            selectedVariantImage: selectedVariant.attrs.image
        });
    }

    handleQuantityChange(event) {
        this.setState({
            selectedVariantQuantity: event.target.value
        });
    }

    decrementQuantity() {
        this.setState({
            selectedVariantQuantity: this.state.selectedVariantQuantity - 1
        })
    }

    incrementQuantity() {
        this.setState({
            selectedVariantQuantity: this.state.selectedVariantQuantity + 1
        })
    }

    render() {
        let variantImage = this.state.selectedVariantImage || this.props.product.images[0]
        let variant = this.state.selectedVariant || this.props.product.variants[0]
        let variantQuantity = this.state.selectedVariantQuantity || 1
        let variantSelectors = this.props.product.options.map((option) => {
            return (
                <VariantSelector
                    handleOptionChange={this.handleOptionChange}
                    key={option.id.toString()}
                    option={option}
                />
            );
        });
        return (
            <div className="Product">
                <div className="product__image-container">
                    {this.props.product.images.length ?
                        <img src={variantImage.src} alt={`${this.props.product.title} product shot`}/> : null}
                </div>
                <div className="product__description-container">


                    <h5 className="Product__title">{this.props.product.title}</h5>

                    <span className="Product__price">${variant.price}</span>

                    {/*{variantSelectors}*/}
                    <div className="product__option-container">
                        <label className="Product__option">
                            <span>Quantity</span>
                            {/*<input min="1" type="number" defaultValue={variantQuantity}*/}
                            {/*       onChange={this.handleQuantityChange}/>*/}
                            {/*       */}
                            <div className="Line-item__quantity-container">
                                <button className="Line-item__quantity-update"
                                        onClick={() => this.decrementQuantity()}>-
                                </button>
                                <span className="Line-item__quantity">{this.state.selectedVariantQuantity}</span>
                                <button className="Line-item__quantity-update"
                                        onClick={() => this.incrementQuantity()}>+
                                </button>
                            </div>

                        </label>
                    </div>


                    <button className="Product__buy button"
                            onClick={() => this.props.addVariantToCart(variant.id, variantQuantity)}>Add to Cart
                    </button>


                </div>


            </div>
        );
    }
}

export default Product;
